"use client";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

function gradingColor(grade: string) {
  const n = Number(grade);
  if (!Number.isFinite(n)) return "bg-white/20";
  if (n >= 9) return "bg-emerald-500";
  if (n >= 7) return "bg-amber-500";
  return "bg-orange-500";
}

export function ListingConditionBadges({
  condition,
  grade,
  className,
}: {
  condition: string;
  grade?: string | null | undefined;
  className?: string;
}) {
  const t = useTranslations("listing");

  const formatConditionLabel = (cond: string) => {
    const trimmed = (cond || "").trim();
    if (!trimmed) return t("conditionUnknown");
    const spaced = trimmed.replace(/[_-]+/g, " ");
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  };

  const normalizedCondition = (condition || "").trim();
  const normalizedGrade = (grade || "").trim();
  const showGrade =
    normalizedGrade.length > 0 &&
    normalizedGrade.toLowerCase() !== "n/a" &&
    normalizedCondition.toLowerCase() !== "new";

  if (!normalizedCondition && !showGrade) return null;

  return (
    <div className={cn("flex items-center gap-2 flex-wrap", className)}>
      {normalizedCondition ? (
        <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-muted text-foreground dark:bg-white/20 dark:text-white">
          {formatConditionLabel(normalizedCondition)}
        </span>
      ) : null}
      {showGrade ? (
        <span
          className={cn(
            "text-xs font-medium px-2.5 py-1 rounded-full",
            gradingColor(normalizedGrade) === "bg-white/20"
              ? "bg-muted text-foreground dark:bg-white/20 dark:text-white"
              : cn(gradingColor(normalizedGrade), "text-white"),
          )}
        >
          {normalizedGrade}/10
        </span>
      ) : null}
    </div>
  );
}
